export enum CK_ENV {
	PRODUCTION = 'production',
	STAGING = 'staging',
	SANDBOX = 'sandbox',
	TEST = 'test',
	LOCAL = 'local'
}
